<template>
  <div class="back-to-top-container" v-show="showButton">
    <van-button
        round
        type="primary"
        icon="arrow-up"
        size="small"
        @click="scrollToTop"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      showButton: false,
      scrollThreshold: 300 // 滚动阈值，超过此值显示按钮
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.showButton = scrollTop > this.scrollThreshold;
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }
};
</script>

<style scoped>
.back-to-top-container {
  position: fixed;
  right: 30px;
  bottom: 80px;
  z-index: 100;
  transition: all 0.3s ease;
}

/* 按钮样式优化 */
.van-button {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;

  /* 阴影效果 */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.van-button::after {
  border: none;
}

/* 响应式调整 */
@media (max-width: 375px) {
  .back-to-top-container {
    right: 15px;
    bottom: 60px;
  }

  .van-button {
    width: 36px;
    height: 36px;
  }
}
</style>
